import gql from "graphql-tag";
const getRawCalcResultQuery = gql(` 
query GetRawCalcResult($params: AWSJSON!) {
  getRawCalcResult(params: $params) {
    status
    profile
    nearest
    result
  }
}
`)
export default getRawCalcResultQuery;
